import { Outlet } from 'react-router-dom';
import AuthRedirect from './AuthRedirect';

/**
 * Root layout component that wraps all routes
 * This allows us to render AuthRedirect inside the Router context
 */
export default function RootLayout() {
  return (
    <>
      <AuthRedirect />
      <Outlet />
    </>
  );
}

